import { z } from 'zod'
import {
	CreateBrokeFlexMessageItemDtoType,
	CreateBrokeFlexMessageItemDtoEligibilityType,
} from '@/modules/messaging/types'

export const notificationItemSchema = z.object({
	type: z.nativeEnum(CreateBrokeFlexMessageItemDtoType),
	order: z.number().min(0),
	eligibilityType: z.nativeEnum(CreateBrokeFlexMessageItemDtoEligibilityType),
	minValue: z.number().optional(),
	displayName: z.string().min(1, 'กรุณากรอกชื่อที่แสดง'),
	icon: z.string().default('🎁'),
	description: z.string().optional(),
	message: z.string().optional(),
	imageUrl: z.string().optional(),
	promotionId: z.string().optional(),
	couponCode: z.string().optional(),
	actionUrl: z.string().optional(),
	enabled: z.boolean().default(true),
})

export const notificationStageSchema = z.object({
	minutesAfterTrigger: z.number().min(0, 'ต้องมากกว่าหรือเท่ากับ 0'),
	message: z.string().min(1, 'กรุณากรอกข้อความ'),
	maxItemsToShow: z.number().min(1).default(3),
	order: z.number().min(0),
	items: z.array(notificationItemSchema).min(1, 'ต้องมีอย่างน้อย 1 รายการ'),
})

export const campaignFormSchema = z.object({
	name: z.string().min(1, 'กรุณากรอกชื่อแคมเปญ'),
	stages: z
		.array(notificationStageSchema)
		.min(1, 'ต้องมีอย่างน้อย 1 ระยะ')
		.max(4, 'สามารถสร้างได้สูงสุด 4 ระยะ'),
})

export type CampaignFormValues = z.infer<typeof campaignFormSchema>

// Re-export enums for use in other components
export {
	CreateBrokeFlexMessageItemDtoType,
	CreateBrokeFlexMessageItemDtoEligibilityType,
}
